import { render, staticRenderFns } from "./gjs.vue?vue&type=template&id=22803aa4&"
import script from "./gjs.vue?vue&type=script&lang=js&"
export * from "./gjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports